import { BRAND } from "./content";

export const LogoMark = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
    <rect width="32" height="32" rx="8" fill="#0B1424" stroke="rgba(45,226,208,0.35)" />
    <circle cx="9.5" cy="16" r="3.2" fill="#2DE2D0" />
    <path d="M15 22.5 L20.5 15.5 L23 18.5 L27 10" fill="none" stroke="#2DE2D0" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5" data-testid="brand-logo">
    <LogoMark />
    <span className="font-serif-d text-2xl tracking-tight text-white">{BRAND}</span>
  </span>
);
